



























import { Component, Prop, Vue } from 'vue-property-decorator'
import axiosInstance from '@/plugins/axios'
import { EventBus, FILE_REMOVED } from '@/plugins/eventBus'
import axios from 'axios'

@Component({
  name: 'file-detail'
})
export default class FileDetail extends Vue {
  @Prop()
  file: IFile

  @Prop()
  fileName: string

  @Prop()
  type: string

  @Prop({ default: false })
  isLasted: boolean

  @Prop({ default: false })
  hasMultipleFile: boolean

  isRemoving = false

  get formattedDate () {
    const dateTime = new Date(this.file.txtime)
    const hours = dateTime.getHours()
    const minutes = dateTime.getMinutes()
    const time = this.padZero(hours) + ':' + this.padZero(minutes)

    const date = this.padZero(dateTime.getDate())
    const month = this.padZero(dateTime.getMonth() + 1)
    const DDMM = `${date}/${month}`

    const year = dateTime.getFullYear()
    const DDMMYYY = `${DDMM}/${year}`
    return DDMMYYY + ' ' + time
  }

  padZero (number) {
    return number.toString().padStart(2, '0')
  }

  async deleteScore () {
    this.isRemoving = true
    try {
      await axiosInstance.delete('/scores', {
        params: { fileId: this.file.fileId }
      })
      EventBus.$emit(FILE_REMOVED, { fileName: this.fileName, fileId: this.file.fileId })
    } catch (error) {
      alert('Delete score failed')
    }
    this.isRemoving = false
  }

  async downloadXLSX () {
    const res = await axiosInstance.get('/files/download', {
      params: {
        fileId: this.file.fileId,
        type: this.type
      }
    })

    const response = await axios.get(res.data.fileUrl, {
      responseType: 'blob'
    })

    const link = document.createElement('a')
    const url = window.URL.createObjectURL(new Blob([response.data]))
    link.setAttribute('href', url)
    link.setAttribute('download', `${this.fileName}.xlsx`)
    link.click()
  }
}
